module.exports = __webpack_public_path__ + "static/0087-7469ac86f42f8da306c72d11c70346a5.png";